import jwt_decode from 'jwt-decode';
import CalCalDataApi from '../../api/CalCalDataApi';

export default async function doDemo(demo, dispatch) {
	/*  takes the place of the PIN screen!
        post to demos, get a JWT :)
    //set the appropriate login store things
    //...should navigate us automatically but need to skip pin somehow
    */
	const res = await CalCalDataApi.demoLogin(demo.id);
	if (__DEV__) console.log(res); //then onSuccess
	if (res.token) {
		var userinfo = jwt_decode(res.token);
		dispatch({
			type: 'SET_JWT',
			token: res,
			info: userinfo
		});

		//const nav = this.props.navigation;

		CalCalDataApi.dataLoad('initLoad', res.token, res => {
			if (!res.error && !res.exception) {
				dispatch({
					type: 'Init/InitLoad',
					data: res
				});
				dispatch({
					type: 'SET_USER',
					user: { demo: true }
				});
			}
			/*
            const resetAction = StackActions.reset({
                index: 0,
                key: null,
                actions: [NavigationActions.navigate({ name: 'Drawer' })]
            });
            this.props.navigation.dispatch(resetAction);
*/
			//console.log('initLoad ', res);
		});
	} else {
		//well something failed ... perhaps had too many!
	}
}
